import {
  FC,
  useEffect,
  memo,
  useCallback,
  useRef,
  MutableRefObject,
  useState,
} from "react";
import JSONString from "../components/JSONString";
import AdminPage from "../AdminPage";
import { apiClient } from "../../utils/apiClient";
import { AppThunk } from "../../store";
import { useParams } from "react-router-dom";

interface AnswerDisplayProps {
  answer: string | null | undefined;
}

const AnswerDisplay: FC<AnswerDisplayProps> = ({ answer }) => {
  const [isValidJSON, setIsValidJSON] = useState(false);
  const [parsedJSON, setParsedJSON] = useState<any>(null);

  useEffect(() => {
    if (!answer || typeof answer !== "string") {
      setIsValidJSON(false);
      setParsedJSON(null);
      return;
    }

    try {
      const parsed = JSON.parse(answer);
      setIsValidJSON(true);
      setParsedJSON(parsed);
    } catch {
      setIsValidJSON(false);
      setParsedJSON(null);
    }
  }, [answer]);

  if (!answer) {
    return <div style={{ color: "#666" }}>No answer available</div>;
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <h3>Answer:</h3>
      {isValidJSON ? (
        <div>
          <div
            style={{ marginBottom: "10px", color: "#666", fontSize: "14px" }}
          ></div>
          <JSONString data={parsedJSON} />
        </div>
      ) : (
        <div
          style={{
            background: "#f5f5f5",
            padding: "15px",
            borderRadius: "4px",
            whiteSpace: "pre-wrap",
            fontFamily: "monospace",
            border: "1px solid #ddd",
          }}
        >
          {answer}
        </div>
      )}
    </div>
  );
};

export interface Props {}

const Request: FC<Props> = (props: Props): JSX.Element => {
  const { id: requestId } = useParams();
  const [request, setRequest] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await apiClient.post<any>(`/gpt/request/${requestId}`);
        setRequest(data);
      } catch (error) {
        console.error("Error fetching requests:", error);
      }
    };
    fetchData();
  }, [requestId]);

  // Create request data without answer to avoid duplication
  const requestWithoutAnswer = request ? { ...request } : null;
  if (requestWithoutAnswer && "answer" in requestWithoutAnswer) {
    delete requestWithoutAnswer.answer;
  }

  return (
    <AdminPage>
      <div>
        <JSONString data={requestWithoutAnswer} />

        {/* Render answer separately if it exists */}
        {request && request.answer && <AnswerDisplay answer={request.answer} />}
      </div>
    </AdminPage>
  );
};

// server-side data here
export const loadData = (): AppThunk[] => [];

export default memo(Request);
